/**
 * /dashboard/posh/complaints/new — File a complaint.
 *
 * POST /posh/complaints. NOT 2FA-gated.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/posh/complaints/new/page.tsx.
 * "use client" dropped.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PoshModuleShell } from "@/components/shared/posh-module-shell";
import { PoshFeatureGate } from "@/components/posh/posh-feature-gate";
import { ComplaintForm } from "@/components/posh/complaint-form";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/posh/complaints/new",
)({
  component: NewComplaintRoute,
});

function NewComplaintRoute() {
  return (
    <PoshModuleShell
      title="File a complaint"
      description="Your complaint goes to the Internal Complaints Committee. You can track its progress from “My complaints”."
    >
      <PoshFeatureGate>
        <Card>
          <CardContent className="pt-6">
            <ComplaintForm />
          </CardContent>
        </Card>
      </PoshFeatureGate>
    </PoshModuleShell>
  );
}
